import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=154c256f&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"
import style0 from "./Tour.vue?vue&type=style&index=0&id=154c256f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c256f",
  null
  
)

export default component.exports